// extracted by mini-css-extract-plugin
export default {"hideTooltip":"cta-z","fadeIn":"dta-z","delay":"eta-z","recommendedSizeTooltip":"fta-z"};